import { makeAuthorizedRequest } from './requests';

export function getMetrics() {
  return makeAuthorizedRequest('GET', '/metrics/user');
}

export function getAdminMetrics() {
  return makeAuthorizedRequest('GET', '/metrics/team');
}
